/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Create Event Stream Request Body
 */
export interface CreateEventStreamBody { 
    /**
     * The AWS IAM role ARN to assume when publishing to the SNS topic.
     */
    role_arn: string;
    /**
     * The AWS SNS topic ARN.
     */
    topic_arn: string;
    /**
     * The type of the event stream (AWS SNS, GCP Pub/Sub, etc).
     */
    type: CreateEventStreamBody.TypeEnum;
}
export namespace CreateEventStreamBody {
    export type TypeEnum = 'sns';
    export const TypeEnum = {
        Sns: 'sns' as TypeEnum
    };
}


